import superagent from 'superagent'
// import { routes } from '../testing/test'
import { removeRefs, prepareRowsForSaving, getFirstVendorID } from '../utils'
import { MANAGE_USERS } from '../constants/permissions.json'
import { sqlSafe } from '../utils/sqlSafe'

const testUrl = 'https://portal.martzbros.com:8446'

const NODE_ENV = process.env.NODE_ENV
console.log('NODE_ENV', NODE_ENV)
// const baseUrl = process.env.REACT_APP_API_URL
const baseUrl = 'https://portal.martzbros.com:8888'
console.log('baseUrl', baseUrl)

const serviceClient = superagent.agent().timeout({ response: 40000, deadline: 40000 })

export const doubleLoginApiCall = (username, password) => {
  const headers = { username, password }
  return serviceClient.post(`${testUrl}/login`)
    .set(headers)
    .withCredentials()
    .then(r => {
      return serviceClient.post(`${baseUrl}/login`)
        .set(headers)
        .withCredentials()
        .then(rtn => {
          return {
            body: {
              ...rtn.body,
              testHash: r.body.authHash
            }
          }
        })
    })
}

export const loginApiCall = (username, password) => {
  const headers = { username, password }
  return serviceClient.post(`${baseUrl}/login`)
    .set(headers)
    .withCredentials()
}

export const logoutApiCall = ({ username, authHash }) => {
  const headers = { Username: username, AuthHash: authHash }
  return serviceClient.post(`${baseUrl}/logout`)
    .set(headers)
    .withCredentials()
}

export const getUsersApiCall = ({ username, authHash, permissions, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const encodedUsername = encodeURIComponent(username)
  const query = permissions.includes(MANAGE_USERS) ? '' : `?username=${encodedUsername}`
  return serviceClient.get(`${url}/users${query}`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getUserInfoApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/userInfo`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export function confirmUserApiCall({ username, authHash, testHash, overrideUrl }) {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.post(`${url}/user/confirm`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getCrewsApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/crews`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getVendorsApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/vendors`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getEmployeesApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/employees`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getPermissionsApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/permissions`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const upsertUserApiCall = ({ username, authHash, testHash }, user) => {
  const headers = { Username: username }

  if (testHash) {
    serviceClient.put(`${testUrl}/user`)
      .set({ ...headers, AuthHash: testHash })
      .send(user)
      .withCredentials(false).then(() => console.log('it worker'))
  }

  return serviceClient.put(`${baseUrl}/user`)
    .set({ ...headers, AuthHash: authHash })
    .send(user)
    .withCredentials(true)
}

export const getRouteInfoApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/routeInfo`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const searchRoutesApiCall = (search) => {
  return search.length < 3
    ? Promise.resolve([])
    : serviceClient.get(`${baseUrl}/searchRoutes?search=${search}`)
      .then(({ body }) => {
        return body.map(x => {
          return { ...x, label: x.PropAgr_ID.toString(), value: x.PropAgr_ID }
        })
      })
}

export const postJobApiCall = ({ username, authHash, testHash, overrideUrl }, timeSheetId, vendorIdd, rows, longNote, shortNote) => {
  const newRows = prepareRowsForSaving(rows)
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.post(`${url}/job`)
    .set(headers)
    .send({ rows: newRows, timeSheetId, vendorIdd, submitted: true, longNote: sqlSafe(longNote), shortNote: sqlSafe(shortNote) })
    .withCredentials(!overrideUrl)
}

export const saveTimeSheetApiCall = ({ username, authHash, testHash, overrideUrl }, timeSheetId, rows, submitted, longNote, shortNote) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const newRows = prepareRowsForSaving(rows)
  const vendorIdd = getFirstVendorID(rows)

  return serviceClient.post(`${url}/timeSheet`)
    .set(headers)
    .send({ timeSheetId, rows: newRows, vendorIdd, submitted: submitted || false, longNote, shortNote })
    .withCredentials(!overrideUrl)
}

export const getSavedTimeSheetsApiCall = (
  { username, authHash, testHash, overrideUrl },
  timeSheetUsername,
  startDate,
  endDate,
  isPrinted,
  invoiceIsPrinted,
) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const encodedUsername = encodeURIComponent(timeSheetUsername)
  let query = timeSheetUsername ? `?Username=${encodedUsername}` : ''

  if (startDate) {
    if (query.length > 0) {
      query += `&startDate=${startDate}&endDate=${endDate}`
    } else {
      query += `?startDate=${startDate}&endDate=${endDate}`
    }
  }

  if (isPrinted) {
    query += `${query.length > 0 ? '&' : '?'}isPrinted=0`
  }

  if (invoiceIsPrinted) {
    query += `${query.length > 0 ? '&' : '?'}invoiceIsPrinted=0&hasInvoice=1`
  }

  return serviceClient.get(`${url}/timeSheet${query}`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getTimeSheetListingApiCall = (
  { username, authHash, testHash, overrideUrl },
  timeSheetUsername,
  startDate,
  endDate,
  isPrinted,
  invoiceIsPrinted,
) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const encodedUsername = encodeURIComponent(timeSheetUsername)
  let query = timeSheetUsername ? `?Username=${encodedUsername}` : ''

  if (startDate) {
    if (query.length > 0) {
      query += `&startDate=${startDate}&endDate=${endDate}`
    } else {
      query += `?startDate=${startDate}&endDate=${endDate}`
    }
  }

  if (isPrinted) {
    query += `${query.length > 0 ? '&' : '?'}isPrinted=0`
  }

  if (invoiceIsPrinted) {
    query += `${query.length > 0 ? '&' : '?'}invoiceIsPrinted=0&hasInvoice=1`
  }

  return serviceClient.get(`${url}/timeSheet/listing${query}`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getTimesheetById = (
  { username, authHash, testHash, overrideUrl },
  timesheetId
) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  let query = `?TimeSheetID=${timesheetId}`

  return serviceClient.get(`${url}/timeSheet${query}`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getLatLongApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/routeInfoLatLong`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const updateGeocodeApiCall = ({ username, authHash, testHash, overrideUrl }, PropID, Latitude, Longitude) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const sendObj = { PropID: PropID, Latitude: Latitude, Longitude: Longitude }
  return serviceClient.post(`${url}/updateGeoCode`)
    .set(headers)
    .send(sendObj)
    .withCredentials(!overrideUrl)
}

export const emailApiCall = ({ username, authHash, testHash, overrideUrl }, subject, text, html) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const sendObj = { subject: subject, text: text, html: html }
  return serviceClient.post(`${url}/email`)
    .set(headers)
    .send(sendObj)
    .withCredentials(!overrideUrl)
}

export function markTimesheetsPrinted({ username, authHash, testHash, overrideUrl }, timesheetIds) {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const sendObj = {
    timesheetIds
  }

  return serviceClient.post(`${url}/timesheet/print`)
    .set(headers)
    .send(sendObj)
    .withCredentials(!overrideUrl)
}

export function markInvoicesPrinted({ username, authHash, testHash, overrideUrl }, invoiceIds) {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const sendObj = {
    invoiceIds
  }

  return serviceClient.post(`${url}/invoice/print`)
    .set(headers)
    .send(sendObj)
    .withCredentials(!overrideUrl)
}

export function emailInvoice({ username, authHash, testHash, overrideUrl }, subject, filename, content, timesheetId, vendorId) {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl
  const body = `Timesheet ID: ${timesheetId}`

  const sendObj = {
    subject: subject,
    text: body,
    html: `<div>${body}</div>`,
    timesheetId,
    username,
    vendorId,
    attachments: [
      {
        filename,
        content,
        encoding: 'base64'
      }
    ]
  }
  return serviceClient.post(`${url}/timesheet/invoice`)
    .set(headers)
    .send(sendObj)
    .withCredentials(!overrideUrl)
}

export const deleteTimesheetApiCall = ({ username, authHash, testHash, overrideUrl }, timesheetId) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.delete(`${url}/timesheet`)
    .set(headers)
    .send({ timesheetId })
    .withCredentials(!overrideUrl)
}

export const getEventsApiCall = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/events`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getEquipTypes = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/equip`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getInvoices = ({ username, authHash, testHash, overrideUrl }, invoiceIds) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/invoices?invoiceIds=${invoiceIds}`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const saveInvoice = ({ username, authHash, testHash, overrideUrl }, invoiceObj) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.post(`${url}/invoices`)
    .set(headers)
    .send(invoiceObj)
    .withCredentials(!overrideUrl)
}

export const getVendor = ({ username, authHash, testHash, overrideUrl }, vendorId) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/vendor?vendorId=${vendorId}`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const forgotPasswordApiCall = (email) => {
  return serviceClient.post(`${baseUrl}/reset/email`)
    .send({ email })
    .withCredentials()
}

export const checkTokenApiCall = (token) => {
  return serviceClient.post(`${baseUrl}/reset/check`)
    .send({ token })
    .withCredentials()
}

export const resetPasswordApiCall = (token, password) => {
  return serviceClient.post(`${baseUrl}/reset`)
    .send({ token, password })
    .withCredentials()
}

export const impersonationApiCall = ({ username, authHash, testHash, overrideUrl }, impersonationUsername) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  const encodedUsername = encodeURIComponent(impersonationUsername)
  const query = `?username=${encodedUsername}`
  return serviceClient.get(`${url}/impersonate${query}`)
    .set(headers)
    .withCredentials(!overrideUrl)
}

export const getVendorReport = ({ username, authHash, testHash, overrideUrl }) => {
  const headers = { Username: username, AuthHash: overrideUrl ? testHash : authHash }
  const url = overrideUrl ? testUrl : baseUrl

  return serviceClient.get(`${url}/vendors/report`)
    .set(headers)
    .withCredentials(!overrideUrl)
}